import React, { useState } from 'react';
import OrderList from '../components/OrderList'; // Full Order List Component
import OrderEdit from '../components/OrderEdit'; // Edit Order Component

const OrderHub = () => {
  const [activeTab, setActiveTab] = useState('orders'); // Default to Order List Tab

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <h1 className="text-2xl font-bold mb-6">Order Management System</h1>
      <div className="flex gap-6 mb-4">
        <button
          className={`px-4 py-2 rounded-md ${activeTab === 'orders' ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          onClick={() => setActiveTab('orders')}
        >
          Full Order List
        </button>
        <button
          className={`px-4 py-2 rounded-md ${activeTab === 'edit' ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          onClick={() => setActiveTab('edit')}
        >
          Edit Order
        </button>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-md">
        {activeTab === 'orders' && <OrderList />}
        {activeTab === 'edit' && <OrderEdit />}
      </div>
    </div>
  );
};

export default OrderHub;
